/**
 * LedgerBalance — шапка лицевого счёта: сколько у клиники на счёте.
 *
 * Флаг `autopayEnabled` здесь намеренно не показываем. Автосписание у
 * нас пока не запущено: что бы ни стояло в настройках клиники, месяц
 * сам не спишется. Зелёная плашка «автоплатёж включён» читалась бы как
 * «продление пройдёт само» — и менеджер не позвонил бы клинике, которая
 * через три дня встанет. Пустая плашка хуже, чем её отсутствие.
 *
 * Вместо неё — то, что сейчас правда для всех: клиника продлевает сама,
 * из кабинета или из приложения. Остаток важен потому, что оплатить с
 * него — один из двух способов, и менеджер видит, хватает ли денег.
 *
 * Когда автосписание включат, флаг вернётся сюда вместе с ним.
 */

import {Button} from '@components/ui/Button';
import {cn} from '@lib/utils';
import {formatTiyin} from '@utils/format';

type Props = {
  balanceTiyin: number;
  onManualEntry: () => void;
};

export const LedgerBalance = ({balanceTiyin, onManualEntry}: Props) => (
  <div className="rounded-[13px] border border-skr-line bg-card px-[18px] py-4">
    <div className="text-[12.5px] text-muted-foreground">Остаток на счёте</div>
    <div
      className={cn(
        'mt-1 font-mono text-[26px] font-bold -tracking-[.02em]',
        balanceTiyin < 0 && 'text-destructive',
      )}
    >
      {formatTiyin(balanceTiyin)}
    </div>
    <div className="mt-2 text-[12.5px] leading-[1.45] text-muted-foreground">
      Клиника продлевает подписку сама — картой или с этого остатка. Автосписание пока не работает,
      само ничего не спишется.
    </div>
    <Button variant="outline" className="mt-3.5 h-10 w-full rounded-[10px]" onClick={onManualEntry}>
      Провести операцию вручную
    </Button>
  </div>
);
